import { Checkbox } from "antd";
import { Button } from "@kalodata/kds-design";
import { Trans } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { VideoSpecs } from "@components/VideoSpecs";
import { IconLoading } from "@icons/index";
import { IconSolidAI } from "@kalodata/kds-design-icons";
import { useVideoRemakeStudio } from "./VideoRemakeStudioContext";

const ACTION_BUTTON_CLASS = twMerge(
  "h-[40px] min-w-[120px] px-[12px]",
  "bg-kds-dark-reverse text-kds-light-reverse shadow-[0_1px_3px_0_var(--kds-shadow)]",
  "hover:bg-(--palette-slate-11) hover:text-kds-light-reverse",
);

export const VideoRemakeStudioFooter = () => {
  const {
    videoSpecs,
    setVideoSpecs,
    showSaveProductEntity,
    saveProductEntity,
    setSaveProductEntity,
    needAiAnalyze,
    canAiAnalyze,
    aiAnalyzing,
    aiAnalyze,
    canGenerate,
    generating,
    creditCost,
    creditLoading,
    generate,
  } = useVideoRemakeStudio();

  const creditDisplay = creditLoading ? "…" : creditCost !== null && creditCost !== undefined ? creditCost : "—";

  return (
    <footer className="flex shrink-0 items-center justify-end gap-[8px] border-t border-kds-border px-[24px] pb-[24px] pt-[16px]">
      <div className="flex flex-1 items-start gap-[8px]">
        <VideoSpecs value={videoSpecs} onChange={setVideoSpecs} />
      </div>

      <div className="flex items-center gap-[8px]">
        {showSaveProductEntity && (
          <Checkbox checked={saveProductEntity} onChange={(e) => setSaveProductEntity(e.target.checked)}>
            <span className="text-[14px] leading-[18px] text-kds-fg whitespace-nowrap">
              <Trans>Save Product Entity</Trans>
            </span>
          </Checkbox>
        )}

        {needAiAnalyze ? (
          <Button
            type="reverse"
            size="lg"
            disabled={!canAiAnalyze || aiAnalyzing}
            onClick={aiAnalyze}
            className={ACTION_BUTTON_CLASS}
          >
            {aiAnalyzing ? <IconLoading className="size-5 animate-spin" /> : <Trans>AI Analyze</Trans>}
          </Button>
        ) : (
          <Button
            type="reverse"
            size="lg"
            disabled={!canGenerate || generating}
            onClick={generate}
            className={ACTION_BUTTON_CLASS}
          >
            {generating ? (
              <IconLoading className="size-5 animate-spin" />
            ) : (
              <>
                <Trans>Generate</Trans>
                <span className="ml-[8px] flex h-[22px] items-center gap-[2px] rounded-full bg-kds-on-dark px-[4px]">
                  <IconSolidAI size={16} className="shrink-0 text-[#FFB727]" />
                  <span className="text-[14px] font-semibold leading-[22px]">{creditDisplay}</span>
                </span>
              </>
            )}
          </Button>
        )}
      </div>
    </footer>
  );
};
